import { render } from "./TheScore.vue?vue&type=template&id=73d2de02"
import script from "./TheScore.vue?vue&type=script&lang=js"
export * from "./TheScore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__